import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import EzvizPlayer from '@/components/EzvizPlayer';
import { getYs7Token } from '@/redux/app/appSlice';
import { EZVIZ_CONFIG } from '@/views/dashboard/modal/config';

const DEVICE_SERIAL = EZVIZ_CONFIG.deviceSerial;
const CHANNEL_NO = Number(EZVIZ_CONFIG.channelNo) || 1;
const LIVE_URL = `ezopen://open.ys7.com/${DEVICE_SERIAL}/${CHANNEL_NO}.hd.live`;
const DECODE_W = 1280;
const DECODE_H = 720;

function ServiceMonitor() {
  const dispatch = useDispatch();
  const ys7Token = useSelector((state) => state.app.ys7Token) || '';
  const videoBoxRef = useRef(null);
  const [time, setTime] = useState(() => new Date());
  const [playerBox, setPlayerBox] = useState({ w: 0, h: 0 });

  useEffect(() => {
    const timer = setInterval(() => {
      setTime(new Date());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (ys7Token) return undefined;
    dispatch(getYs7Token()).unwrap().catch(() => {});
    return undefined;
  }, [dispatch, ys7Token]);

  useEffect(() => {
    const el = videoBoxRef.current;
    if (!el) return undefined;
    const update = () => {
      const w = el.offsetWidth || 0;
      const h = el.offsetHeight || 0;
      setPlayerBox((prev) => (prev.w === w && prev.h === h ? prev : { w, h }));
    };
    update();
    const ro = new ResizeObserver(update);
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  const formatTime = (date) => {
    return date.toLocaleTimeString('zh-CN', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
  };

  const formatDate = (date) => {
    return date.toLocaleDateString('zh-CN', { year: 'numeric', month: '2-digit', day: '2-digit' });
  };

  const canPlay = Boolean(ys7Token) && playerBox.w >= 8 && playerBox.h >= 8;
  const fitScale = canPlay
    ? Math.max(playerBox.w / DECODE_W, playerBox.h / DECODE_H)
    : 1;

  return (
    <div className="service-monitor">
      <div className="monitor-header">
        <div className="monitor-camera-info">
          <span className="live-dot"></span>
          <span className="camera-id">{DEVICE_SERIAL}</span>
        </div>
        <div className="monitor-time">
          <span className="date">{formatDate(time)}</span>
          <span className="time">{formatTime(time)}</span>
        </div>
      </div>

      <div className="monitor-video" ref={videoBoxRef}>
        {canPlay ? (
          <EzvizPlayer
            containerId={`vs-service-monitor-${DEVICE_SERIAL}`}
            accessToken={ys7Token}
            url={LIVE_URL}
            deviceSerial={DEVICE_SERIAL}
            channelNo={CHANNEL_NO}
            mode="live"
            rotateDeg={180}
            active
            recreateToken={`${DECODE_W}x${DECODE_H}`}
            playerProps={{ width: DECODE_W, height: DECODE_H }}
            wrapperStyle={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              width: DECODE_W,
              height: DECODE_H,
              marginLeft: -DECODE_W / 2,
              marginTop: -DECODE_H / 2,
              transform: `scale(${fitScale})`,
              transformOrigin: 'center center'
            }}
          />
        ) : (
          <div className="monitor-video-empty">正在连接摄像头...</div>
        )}
        <div className="video-overlay">
          <span className="recording-dot"></span>
          <span className="recording-text">REC</span>
        </div>
        <div className="monitor-resolution">1080P</div>
      </div>
    </div>
  );
}

export default ServiceMonitor;
